import { Grid } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Button } from "@roc/ui";
import { observer } from "mobx-react";

export const NotFullySubmittedAlert = observer(({ }) => {
  return (
    <Grid item xs={12}>
      <Alert
        severity='info'
        icon={false}
        style={{
          display: 'grid',
        }}
      >
        <AlertTitle>
          <Grid container direction='row' alignItems='center' justifyContent="space-between">
            <Grid item xs={10}>
              <b>We are currently processing your loan submission. This should take a couple of minutes to complete. After that you will see the next steps for your loan.</b>
            </Grid>
            <Grid item>
              <Button
                size='small'
                variant='contained'
                onClick={() => location.reload()}
                testId='refreshLoan'
                style={{
                  backgroundColor: '#253e5d',
                  color: '#eef5fc',
                }}
              >
                <span>Refresh</span>
                <Refresh fontSize='small' />
              </Button>
            </Grid>
          </Grid>
        </AlertTitle>
      </Alert>
    </Grid>
  );
});